import { getAbout } from './getAbout'
import { getSeo } from './getSeo'

export * from './getAbout'
export * from './getSeo'

export const ourHistoryApi = {
  getAbout,
  getSeo,
}
